Jadelet from jadelet

window.system =
  ui: {
    Jadelet
  }
